import {Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Button from "react-bootstrap/Button";
import Dropdown from "../../../primer/Dropdown";
import Input from "../../../common/Input";
import axios from "axios";
import {toast} from "react-toastify";
import {useSelector} from "react-redux";

const DemoVectorSearchModal = ({show, setShow}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [input, setInput] = useState("");
    const [type, setType] = useState("");
    const [loader, setLoader] = useState(false);
    const [console, setConsole] = useState([]);

    useEffect(() => {
        if(show) {
            setInput("");
            setType("");
            setLoader(false);
            setConsole(null);
        }
    }, [show]);


    const typeOptions = [
        {value: "", label: "Παρακαλώ επιλέξτε κατηγορία"},
        {value: "products", label: "Είδη"},
        {value: "clientsSuppliers", label: "Πελάτες-Προμηθευτές"},
        {value: "transactions", label: "Τραπεζικές Συναλλαγές"},
        {value: "employees", label: "Εργαζόμενοι"}
    ];

    const vectorSearch = () => {
        setLoader(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/ai/demo-vector-search`, {company: company.id, input, type}).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής Αναζήτηση.");
                setConsole(res.data.data);
            } else {
                setConsole([]);
                toast.error(res.data.message);
            }
            setLoader(false);
        }).catch((err) => {
            setLoader(false);
            setConsole([]);
            toast.error("Κάτι πήγε στραβά!");
        })
    }


    return (
        <Modal backdrop={"static"} className="themeModal" show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Demo Vector Search</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Dropdown
                    name={"type"}
                    label={"Κατηγορία Αναζήτησης"}
                    className={"w-100"}
                    required={true}
                    defaultValue={typeOptions.find((el) => el.value === type)}
                    key={Math.random()}
                    options={typeOptions}
                    onChange={(e) => setType(e.value)}
                />
                <Input
                    label={"Κείμενο Αναζήτησης"}
                    name={"input"}
                    disabled={loader}
                    placeholder={"Εισάγετε Κείμενο Αναζήτησης"}
                    type={"text"}
                    required={true}
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                />
                {console?.length > 0 && (
                    <React.Fragment>
                        <hr />
                        <div className="row">
                            <div className="mb-2 col-12">
                                <div className="bg-light w-100 border p-3">
                                    {console.map((e, i) => (
                                        <pre key={i} className="mb-2">
                                            {JSON.stringify(e, null, 2)}
                                        </pre>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <hr />
                    </React.Fragment>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="primary"
                    disabled={loader}
                    onClick={() => vectorSearch()}>
                    {"Αναζήτηση Vector "}
                    {loader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DemoVectorSearchModal;